import React, { useState } from "react";
import { BasketFill, ChevronLeft } from "react-bootstrap-icons";
import AccardionItem from "../AccardionItem/AccardionItem";
import Style from "../Accardion.module.scss";
import { Badge } from "antd";

const Accardion4 = ({dataCount}) => {
  const [openOnClick, setOpenOnClick] = useState(false);
  const totalCount=parseInt(dataCount?.supplier_comment_food)+parseInt(dataCount?.supplier_comment_supermarket)
  const comment = [
    {
      id: "1",
      title: "رستوران",
      link: "/restaurantcomment",
      active: window.location.pathname === "/restaurantcomment",
      count:parseInt(dataCount?.supplier_comment_food)
    },
    {
      id: "2",
      title: " فروشگاه",
      link: "/supermarketcomment",
      active: window.location.pathname === "/supermarketcomment",
      count:parseInt(dataCount?.supplier_comment_supermarket)
    },
  ];
  let value = false;
  comment.forEach((element) => {
    if (element.active) {
      value = true;
    }
  });
  const openHandler = () => {
    if (openOnClick) {
      setOpenOnClick(false);
    } else {
      setOpenOnClick(true);
    }
  };
  return (
    <div className={Style.accardionChild}>
      <div
        onClick={openHandler}
        className={
          value || openOnClick ? Style.background : Style.accardionTitle
        }
      >
        <ChevronLeft />
        <div className={Style.right}>
          <p className={Style.accardionText}> <Badge count={totalCount}/> نظرات </p>
          <BasketFill />
        </div>
      </div>
      {comment === undefined ? null : (
        <div
          className={
            value || openOnClick ? Style.accardionContent : Style.hidden
          }
        >
          <AccardionItem accardonItem={comment && comment} />
        </div>
      )}
    </div>
  );
};

export default Accardion4;
